import hoSakshamHorizontal from "../../../../assets/HosakshamHorizontal.png"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import errorImage from "../../../../assets/GifsAndPlaceholders/404Error.gif"
import {SECRETS_ENV} from "../../../../Config/firebase.ts";


export default function PageNotFound() {



    return (


        <div className="h-screen w-screen bg-gray-50 flex items-center relative">
            <img src={hoSakshamHorizontal} onClick={() => {
                window.open(SECRETS_ENV.BASE_URL)
            }} alt="HosakshamHorizontal"
                 className={"h-auto w-[200px] top-4 left-32  absolute cursor-pointer"}/>
            <div className="container flex flex-col md:flex-row items-center justify-between px-32 text-gray-700">
                <div className="w-full lg:w-1/2 mx-8">
                    <div className="text-7xl text-cc_brand font-dark font-extrabold mb-8"> 404</div>
                    <p className="text-2xl md:text-3xl font-semibold leading-normal my-8 mb-16 ">
                        We can't seem to find the page you are looking for.
                    </p>

                    <a href={SECRETS_ENV.BASE_URL} target="_blank" rel="noopener noreferrer"
                       className="px-5 inline py-3 text-sm font-medium leading-5 shadow-2xl text-white transition-all duration-400 border border-transparent rounded-lg focus:outline-none bg-cc_brand active:bg-red-600 hover:bg-red-700">Back
                        to Homepage</a>
                </div>
                <div className="w-full lg:flex lg:justify-end lg:w-1/2 mx-5 my-12">
                    <img src={errorImage} className="" alt="Page not found"/>
                </div>

            </div>
            <div className={"absolute bottom-4 right-0 left-0 px-32 font-medium"}>
                <div className={"text-sm flex justify-between w-full items-center"}>
                    <div className={"flex gap-2 items-center"}>
                        <a href="https://hosaksham.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms
                            Of Service</a>
                        <div className={"border-l-[1px] h-4 border-solid border-black"}>

                        </div>
                        <a href="https://hosaksham.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy
                            Policy</a>
                    </div>
                    <div>
                        <p>© 2024, EagleX Sas Makers Pvt. Ltd. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </div>

    )

}